import React from "react";
import ToolbarHeader from "../../components/ToolbarHeader";
import { icons } from "../../assets/icons";
import PreviewDoc from "./PreviewDoc";
import PDF_KV from './pdf/Keventers_projects.pdf'

const HelpCenter = () => {
  const cards = [
    {
      title: "Product Manual",
      icon: icons.helpIcon,
      description:
        "Explore our online product manual for detailed information and guidance on how to effectively use the product.",
      description2: "View the help documents",
      link: "",
      onClick: () => window.open("/static/media/Keventers_projects.c8c15ca849bdd3f2de2e.pdf", "_blank")
      // onClick: () => window.open("/static/media/Keventers_projects.43bbb90b4060259f434d.pdf", "_blank")
    },
    // {
    //   title: "FAQ",
    //   icon: icons.faqIcon,
    //   description:
    //     "Explore detailed help documents for comprehensive guidance and instructions.",
    //   description2: "View the help documents",
    //   link: "",
    // },
    // {
    //   title: "What's New",
    //   icon: icons.newIcon,
    //   description:
    //     "Explore detailed help documents for comprehensive guidance and instructions.",
    //   description2: "View the help documents",
    //   link: "",
    // },
    // {
    //   title: "Send Us An Email",
    //   icon: icons.sendMailIcon,
    //   description:
    //     "Explore detailed help documents for comprehensive guidance and instructions.",
    //   description2: "View the help documents",
    //   link: "",
    // },
    // {
    //   title: "Request A Feature",
    //   icon: icons.requestIcon,
    //   description:
    //     "Explore detailed help documents for comprehensive guidance and instructions.",
    //   description2: "View the help documents",
    //   link: "",
    // },
  ];

  return (
    <div className="dashboard-container">
      <ToolbarHeader
        title="Help Center"
        showBack={false}
        containerClassName="mt-14"
      />

      <div className="mt-6 flex items-stretch flex-wrap gap-10">
        {cards.map((item) => {
          return (
            <div
              key={item.title}
              className="flex flex-col gap-y-8 w-[32rem] min-h-[25.6rem] rounded-[1rem] px-10 py-7 bg-[var(--whiteColor)] cursor-pointer"
              onClick={item.onClick}
            >
              <div className="flex gap-x-12">
                <img src={item.icon} alt={item.title} />
                <div className="text-[2.2rem] font-family-medium">
                  {item.title}
                </div>
              </div>
              <div className="font-size-medium text-[var(--textGray2)] flex-1">
                {item.description}
              </div>
              <div className="flex items-center gap-x-3">
                <img src={icons.arrowRight} alt="arrow right" />
                <div className="font-size-small font-family-medium">
                  {item.description2}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {/* <PreviewDoc pdfUrl={PDF_KV} /> */}
    </div>
  );
};

export default HelpCenter;
